import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store";

import Login from "@/views/Login";
import ForgotPassword from "@/views/ForgotPassword";
import ProjectList from "@/views/ProjectList";
import ProjectConnect from "@/views/ProjectConnect";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      public: true
    }
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      public: true
    }
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter: (to, from, next) => {
      store.dispatch("logout");
      store.dispatch("revokeCubejsToken");
      next({
        name: "Login"
      });
    },
    meta: {
      public: true
    }
  },
  {
    path: "/projects",
    name: "ProjectList",
    component: ProjectList
  },
  {
    path: "/connect/:id",
    name: "ProjectConnect",
    component: ProjectConnect
  },
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const toPublic = !!to.meta.public;
  const toPrivate = !toPublic;
  const noToken = !store.getters.token;

  if (toPrivate && noToken) {
    next({
      name: "Login"
    });
  } else {
    next();
  }
});

export default router;
